import { BASEURLPROJETOS } from '../api/projetos'
import BASEAPIPROJETOS from '../api/formDataProjetos'
import { payloadCadastrarDocumento, subistutirDocumentoPayload } from '../../interfaces/projetosDocumentos'

export function cadastrarDocumentoProjeto(payload: payloadCadastrarDocumento) {
  return BASEAPIPROJETOS.post(`/projetos/documento`, payload)
}

export function listarProjetosDocumentos(idProjeto: string) {
  return BASEURLPROJETOS.get(`/projetos/documento/${idProjeto}`)
}

export function deletarDocumentoController(idDocumento: string) {
  return BASEURLPROJETOS.delete(`/projetos/documento/${idDocumento}`)
}

export function substituirDocumentoProjeto (idDocumento: string, payload: subistutirDocumentoPayload) {
    return BASEAPIPROJETOS.patch(`/projetos/documento/${idDocumento}`, payload)
}